import React, { useState, useRef } from 'react';

import VideoCard from "./VideoCard";
import VideoPlayer from "./VideoPlayer";
import "../styles/VideoGallery.css";

// Videos propios de la empresa
const videos = [
  {
    id: 1,
    title: "House Cleaning",
    description: "Profesional cleaning service for homes",
    src: "/videos/houseCleaning.mp4",
    duration: "0:37"
  },
  {
    id: 2,
    title: "Office Cleaning",
    description: "Specialized service for workspaces",
    src: "/videos/officeVacuum.mp4",
    duration: "0:19"
  },
  {
    id: 3,
    title: "Window Cleaning",
    description: "Professional window cleaning service",
    src: "/videos/windowOfficeCleaning.mp4",
    duration: "0:42"
  }
];

// Componente principal de la galería de videos
const VideoGallery = () => {
  const [selectedVideo, setSelectedVideo] = useState(videos[0]);
  const playerRef = useRef(null);

  const handleSelectVideo = (video) => {
    setSelectedVideo(video);

    // En pantallas pequeñas, desplazar suavemente al reproductor
    if (window.innerWidth < 992 && playerRef.current) {
      setTimeout(() => {
        const yOffset = -90; // margen para el navbar fijo
        const element = playerRef.current;
        const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

        window.scrollTo({ top: y, behavior: 'smooth' });
      }, 100);
    }
  };

  return (
    <section className="sec sec--white" id='VideoGallery'>
      <div className="container">
        <div className="sec-head">
          <span className="eyebrow">On the job</span>
          <h2 className="sec-title">Our crews, filmed at work</h2>
          <p className="sec-lede">
            Short clips shot on real jobs around Los Angeles — no stock footage.
          </p>
        </div>

        <div className="vgallery">
          <div ref={playerRef}>
            <VideoPlayer video={selectedVideo} />

            <div className="vgallery__now">
              <h3>{selectedVideo.title}</h3>
              <p>{selectedVideo.description}</p>
            </div>
          </div>

          <div className="vgallery__aside">
            <div className="vgallery__asideHead">
              <h3 className="mono-label">All clips</h3>
              <span className="chip">{videos.length}</span>
            </div>

            <div className="vgallery__list">
              {videos.map(video => (
                <VideoCard
                  key={video.id}
                  video={video}
                  onSelectVideo={handleSelectVideo}
                  isSelected={selectedVideo.id === video.id}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoGallery;
